import { Component, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, NavigationEnd, ActivatedRoute, Data, RouterModule } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators';
import { CoreService } from 'src/app/services/core.service';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

import {
  ApexChart,
  ChartComponent,
  ApexDataLabels,
  ApexLegend,
  ApexStroke,
  ApexTooltip,
  ApexAxisChartSeries,
  ApexXAxis,
  ApexYAxis,
  ApexGrid,
  ApexPlotOptions,
  ApexFill,
  ApexMarkers,
  NgApexchartsModule,
} from 'ng-apexcharts';
import { RouteParamsHandlerService } from 'src/app/services/route-params-handler.service';
import { Subscription } from 'rxjs';
import { PilotSchoolsService } from 'src/app/services/pilot-schools.service';
import { LoadingService } from 'src/app/services/loading.service';
import { AuthService } from 'src/app/services/auth.service';
import { ClassesService } from 'src/app/services/classes.service';


export interface breadcrumbOption {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  yaxis: ApexYAxis;
  xaxis: ApexXAxis;
  fill: ApexFill;
  tooltip: ApexTooltip;
  stroke: ApexStroke;
  legend: ApexLegend;
  grid: ApexGrid;
  marker: ApexMarkers;
}


@Component({
  selector: 'app-breadcrumb',
  standalone: true,
  imports: [NgApexchartsModule, RouterModule, TranslateModule, CommonModule],
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
})
export class AppBreadcrumbComponent {
  @ViewChild('chart') chart: ChartComponent = Object.create(null);

  public breadcrumbOption!: Partial<breadcrumbOption> | any;
  public breadcrumb2Option!: Partial<breadcrumbOption> | any;

  // @Input() layout;
  pageInfo: Data | any = Object.create(null);

  options = this.settings.getOptions();

  pilot: string = this.authService.pilot;
  role: string = "";
  schoolName: string = "";
  params: any = {};
  paramKey: string = "";

  indicators: any = {};
  indicatorsElements: any = { numberOfElements: 0, keys: [] };

  currentRoute: any = "";

  /** Data subscriptions */
  private pilotSummarySubscription: Subscription = new Subscription();
  private schoolSummarySubscription: Subscription = new Subscription();
  private schoolClassesSubscription: Subscription = new Subscription();
  private classesWithChildrenSubscription: Subscription = new Subscription();

  constructor(
    private settings: CoreService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private routeParamsHandlerService: RouteParamsHandlerService,
    private pilotSchoolsService: PilotSchoolsService,
    private authService: AuthService,
    private classesService: ClassesService
  ) {

    //Manage route params comming from the executed component
    this.routeParamsHandlerService.routeChanged$.subscribe(data => {
      this.params = data;
      if (this.params != '{}') {
        this.paramKey = this.getKeys()[0];
      } else {
        this.paramKey = "";
      }
    })

    this.breadcrumbOption = {
      series: [
        {
          name: '',
          data: [1.1, 1.4, 1.1, 0.9, 1.9, 1, 0.3, 1.1],
        },
      ],
      chart: {
        type: 'bar',
        height: 35,
        width: 60,
        fontFamily: 'Poppins,sans-serif',
        sparkline: {
          enabled: true,
        },
      },
      grid: {
        borderColor: 'rgba(0,0,0,.2)',
        strokeDashArray: 3,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '60%',
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent'],
      },
      xaxis: {
        categories: ['Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'],
      },

      legend: {
        show: false,
      },
      fill: {
        colors: ['#1e88e5'],
        opacity: 1,
      },
      tooltip: {
        enabled: false,
      },
    };

    this.breadcrumb2Option = {
      series: [
        {
          name: '',
          data: [1.1, 1.4, 1.1, 0.9, 1.9, 1, 0.3, 1.1],
        },
      ],
      chart: {
        type: 'bar',
        height: 35,
        width: 60,
        fontFamily: 'Poppins,sans-serif',
        sparkline: {
          enabled: true,
        },
      },
      grid: {
        borderColor: 'rgba(0,0,0,.2)',
        strokeDashArray: 3,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '60%',
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent'],
      },
      xaxis: {
        categories: ['Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'],
      },

      legend: {
        show: false,
      },
      fill: {
        colors: ['#26c6da'],
        opacity: 1,
      },
      tooltip: {
        enabled: false,
      },
    };


    // for breadcrumb
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .pipe(map(() => this.activatedRoute))
      .pipe(
        map((route) => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        })
      )
      .pipe(filter((route) => route.outlet === 'primary'))
      .pipe(mergeMap((route) => route.data))
      // tslint:disable-next-line - Disables all
      .subscribe((event) => {
        // tslint:disable-next-line - Disables all
        this.titleService.setTitle(event['title']);
        this.pageInfo = event;

        this.currentRoute = this.pageInfo.urls;
        
        if(this.currentRoute[0].url == '/section/analysis' || this.currentRoute[0].url == '/section/educationalGallery'){

           this.indicatorsElements.keys = [];
          this.indicatorsElements.numberOfElements = [];

        }
      });
  }

  ngOnInit() {

    //Adapt the breadcrumb information depending on the user role
    if (this.authService.userSessionInfo && this.authService.userSessionInfo.role == "TEACHER_ROLE") {
      this.role = 'educator';
    } else {
      this.role = 'admin';
    }

    this.pilotSummarySubscription = this.pilotSchoolsService.pilotSummary$.subscribe((data: any) => {

      if (!(typeof (data) == 'object')) {

        this.indicators = {
          "schools": "-",
          "educators": "-",
          "interventionStudents": "-",
          "controlStudents": "-"
        }

        this.indicatorsElements.keys = Object.keys(this.indicators);
        this.indicatorsElements.numberOfElements = Object.keys(this.indicators).length;


      } else {

        this.indicators = data;

        this.indicatorsElements.keys = Object.keys(this.indicators);
        this.indicatorsElements.numberOfElements = Object.keys(this.indicators).length;

      }



    });

    this.schoolSummarySubscription = this.pilotSchoolsService.schoolSummary$.subscribe(async (data: any) => {

      if (!(typeof (data) == 'object')) {

        this.indicators = {
          "educators": "-",
          "interventionStudents": "-",
          "controlStudents": "-"
        }

        this.indicatorsElements.keys = Object.keys(this.indicators);
        this.indicatorsElements.numberOfElements = Object.keys(this.indicators).length;


      } else {

        this.indicators = data;

        if (this.role == 'admin') {
          delete this.indicators.blindStudents;
        }

        this.indicatorsElements.keys = Object.keys(this.indicators);
        this.indicatorsElements.numberOfElements = Object.keys(this.indicators).length;

        if (this.role == 'educator') {
          try {
            let schoolData: any = await this.pilotSchoolsService.getSchoolCompleteDataObservable(this.authService.userProfileData.schoolId).toPromise();
            if (schoolData) {
              this.schoolName = schoolData[0].name;
            }

          } catch (error) {

            console.log("Catch error this.pilotSchoolsService.getSchoolCompleteDataObservable():",JSON.stringify(error));

          }

          //admin
        }else {

           try {
            let schoolData: any = await this.pilotSchoolsService.getSchoolCompleteDataObservable(this.params.schoolId).toPromise();
            if (schoolData) {
              this.schoolName = schoolData[0].name;
            }

          } catch (error) {

            console.log("Catch error this.pilotSchoolsService.getSchoolCompleteDataObservable():",JSON.stringify(error));

          }
        }

      }

    });

    this.schoolClassesSubscription = this.pilotSchoolsService.selectedSchoolClasses$.subscribe((data: any) => {   

      if (this.pageInfo.urls[0].url.indexOf('section/intervention')!=-1) {

        if (data.indexOf('error') != -1) {

          this.indicators = {
            "interventionStudents": "-",
            "controlStudents": "-",
            "blindStudents": "-"
          }

          this.indicatorsElements.keys = Object.keys(this.indicators);
        this.indicatorsElements.numberOfElements = Object.keys(this.indicators).length;

        } else {

          let userClasses = [];
          let usersBlind: number = 0;
          let usersControl: number = 0;
          let usersIntervention: number = 0;

          //Get only the educator classes
          if (this.authService.userProfileData.classId.length != 0) {
            userClasses = data.filter((elemento: any) => this.authService.userProfileData.classId.indexOf(elemento.id) != -1);

            usersBlind = userClasses.filter((elemento: any) => elemento.interventionBlind == 1).reduce((suma: number, elemento: any) => suma + (elemento.studentsRegistered || 0), 0);
            usersControl = userClasses.filter((elemento: any) => elemento.interventionBlind == 0 && elemento.groupClassification == 1).reduce((suma: number, elemento: any) => suma + (elemento.studentsRegistered || 0), 0);
            usersIntervention = userClasses.filter((elemento: any) => elemento.interventionBlind == 0 && elemento.groupClassification == 2).reduce((suma: number, elemento: any) => suma + (elemento.studentsRegistered || 0), 0);

            this.indicators = {
              "interventionStudents": usersIntervention,
              "controlStudents": usersControl,
              "blindStudents": usersBlind
            }

            this.indicatorsElements.keys = Object.keys(this.indicators);
            this.indicatorsElements.numberOfElements = Object.keys(this.indicators).length;

          }


        }
      }
    })

    this.classesWithChildrenSubscription = this.classesService.educatorClasses$.subscribe(async (data: any) => {

      if (this.pageInfo.urls[0].url == '/section/students') {

        if (data.indexOf('error') != -1) {
          this.indicators = {
            "interventionStudents": "-",
            "controlStudents": "-",
            "blindStudents": "-"
          }

          this.indicatorsElements.keys = Object.keys(this.indicators);
          this.indicatorsElements.numberOfElements = Object.keys(this.indicators).length;

        } else {

          let userClasses = JSON.parse(JSON.stringify(data));
          let usersBlind: number = 0;
          let usersControl: number = 0;
          let usersIntervention: number = 0;

            usersBlind = userClasses
            .filter((elemento: any) => elemento.interventionBlind === 1)
            .reduce((suma: number, elemento: any) => {
              const count = elemento.children?.filter((child: any) => child.status === 1).length || 0;
              return suma + count;
            }, 0);
            usersControl = userClasses
            .filter((elemento: any) => elemento.interventionBlind === 0 && elemento.groupClassification === 1)
            .reduce((suma: number, elemento: any) => {
              const count = elemento.children?.filter((child: any) => child.status === 1).length || 0;
              return suma + count;
            }, 0);
            usersIntervention = userClasses
            .filter((elemento: any) => elemento.interventionBlind === 0 && elemento.groupClassification === 2)
            .reduce((suma: number, elemento: any) => {
            const count = elemento.children?.filter((child: any) => child.status === 1).length || 0;
            return suma + count;
             }, 0);

             this.indicators = {
              "interventionStudents": usersIntervention,
              "controlStudents": usersControl,
              "blindStudents": usersBlind
            }

            this.indicatorsElements.keys = Object.keys(this.indicators);
            this.indicatorsElements.numberOfElements = Object.keys(this.indicators).length;

        }
      }

    
    })

  }

  /**
 * Method to obtain Object keys
 * @returns keys
 */
  getKeys() {
      const keys = Object.keys(this.params);
      return keys;
    }

  ngOnDestroy() {
      this.pilotSummarySubscription.unsubscribe();
      this.schoolSummarySubscription.unsubscribe();
      this.schoolClassesSubscription.unsubscribe();
      this.classesWithChildrenSubscription.unsubscribe();
    }
}
